"use client";

import { Story, StoryContext } from "@/components/builder/stories/context";
import { ReactNode, useMemo } from "react";

export interface StoryContextProviderProps {
  children: ReactNode;
  story: Story | null;
}

export function StoryContextProvider({ children, story }: StoryContextProviderProps) {
  const ctx: Story | null = useMemo(() => story, []);

  return <StoryContext.Provider value={ctx}>{children}</StoryContext.Provider>;
}
